module.exports = __webpack_public_path__ + "static/media/22.4b2ba679.png";